// External links for the Outpoll mobile app
export const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.outpollapp';
